// Creating the action types for employee modal
export const GET_REIMBURSEMENT_DATA = 'GET_REIMBURSEMENT_DATA';
export const SET_CURRENT_USER_INFORMATION = 'SET_CURRENT_USER_INFORMATION';
export const SET_CLAIM_DATA='SET_CLAIM_DATA';